import React from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';

import AndroidIcon from '../../../images/mrrobot-icon.svg';

const IconBox = ({type, opacity}) => (
  <div style={{height: 15}}>
    {type === 'robot' && (
      <img src={AndroidIcon} style={{opacity}}  />
    )}
    {type === 'eye' && (
      <VisibilityIcon className="admin__eyeicon" style={{opacity}} />
    )}
  </div>
);

export default IconBox;
